import React from "react";
import DecisionButton from "./DecisionButton";

const ButtonGroup = ({
    points,
    penalties,
    athlete,
    position,
    decisionHandlers,
    disabled,
}) => {
    const leftAlignedPointButtons = points.map((point) => (
        <DecisionButton
            buttonId={point.id}
            title={point.title}
            value={point.value}
            athlete={athlete}
            defaultKey={point.defaultKeyLeft}
            onButtonClick={
                athlete === "red"
                    ? decisionHandlers.incrementScoreRed
                    : decisionHandlers.incrementScoreBlue
            }
            disabled={disabled}
        />
    ));

    const leftAlignedPenaltyButtons = penalties.map((penalty) => (
        <DecisionButton
            buttonId={penalty.id}
            title={penalty.title}
            value={penalty.value}
            defaultKey={penalty.defaultKeyLeft}
            athlete={athlete}
            onButtonClick={
                athlete === "red"
                    ? decisionHandlers.incrementPenaltyRed
                    : decisionHandlers.incrementPenaltyBlue
            }
            disabled={disabled}
        />
    ));

    const reversePoints = [...points];
    const rightAlignedPointButtons = reversePoints
        .reverse()
        .map((point) => (
            <DecisionButton
                buttonId={point.id}
                title={point.title}
                value={point.value}
                athlete={athlete}
                defaultKey={point.defaultKeyRight}
                onButtonClick={
                    athlete === "blue"
                        ? decisionHandlers.incrementScoreBlue
                        : decisionHandlers.incrementScoreRed
                }
                disabled={disabled}
            />
        ));

    const reversePenalties = [...penalties];
    const rightAlignedPenaltyButtons = reversePenalties
        .reverse()
        .map((penalty) => (
            <DecisionButton
                buttonId={penalty.id}
                title={penalty.title}
                value={penalty.value}
                athlete={athlete}
                defaultKey={penalty.defaultKeyRight}
                onButtonClick={
                    athlete === "blue"
                        ? decisionHandlers.incrementPenaltyBlue
                        : decisionHandlers.incrementPenaltyRed
                }
                disabled={disabled}
            />
        ));

    return position === "left" ? (
        <div className="leftButtonGrid">
            {leftAlignedPointButtons}
            {leftAlignedPenaltyButtons}
        </div>
    ) : (
        <div className="rightButtonGrid">
            {rightAlignedPenaltyButtons}
            {rightAlignedPointButtons}
        </div>
    );
};

export default ButtonGroup;
